<template>
  <v-main>
    <CommunicationNewMessageContainer />
  </v-main>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from "vue";
import CommunicationNewMessageContainer from '@/container/communication/CommunicationNewMessageContainer.vue';

export default defineComponent({
  components: {
    CommunicationNewMessageContainer,
  },
});
</script>
